(function () {
  const initCarousel = (section) => {
    if (!section || !section.classList.contains("update-image-carousel-section")) {
      return;
    }

    const sliderEl = section.querySelector(".js-update-image-carousel");
    if (!sliderEl || sliderEl.swiper) return;

    const paginationEl = section.querySelector(
      ".update-image-carousel__pagination"
    );
    const autoplayEnabled = sliderEl.dataset.autoplay === "true";
    const slideDuration = Number(sliderEl.dataset.slideDuration || 5000);
    const transitionSpeed = Number(sliderEl.dataset.transitionSpeed || 800);

    const swiperConfig = {
      slidesPerView: "auto",
      spaceBetween: Number(sliderEl.dataset.gap || 24),
      speed: transitionSpeed,
      loop: sliderEl.dataset.loop === "true",
      watchSlidesProgress: true,
      mousewheel: {
        forceToAxis: true,
      },
      on: {
        init(swiper) {
          setPaginationProgress(swiper, autoplayEnabled ? 0 : 1);
        },
        slideChange(swiper) {
          setPaginationProgress(swiper, 0);
        },
        autoplayTimeLeft(swiper, time, progress) {
          setPaginationProgress(swiper, 1 - progress);
        },
      },
    };

    if (paginationEl) {
      swiperConfig.pagination = {
        el: paginationEl,
        clickable: true,
      };
    }

    if (autoplayEnabled) {
      swiperConfig.autoplay = {
        delay: slideDuration,
        disableOnInteraction: false,
        pauseOnMouseEnter: sliderEl.dataset.pauseOnHover === "true",
      };
    }

    new Swiper(sliderEl, swiperConfig);
  };

  const setPaginationProgress = (swiper, progress) => {
    if (!swiper.pagination?.bullets?.length) return;

    swiper.pagination.bullets.forEach((bullet, index) => {
      const bulletProgress = index === swiper.realIndex ? progress : 0;
      bullet.style.setProperty("--progress", Math.max(0, bulletProgress));
    });
  };

  initCarousel(document.currentScript.parentElement);

  document.addEventListener("shopify:section:load", function (event) {
    initCarousel(event.target);
  });

  document.addEventListener("shopify:section:unload", function (event) {
    const sliderEl = event.target.querySelector(".js-update-image-carousel");
    if (sliderEl?.swiper) sliderEl.swiper.destroy();
  });
})();
